import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { Image, H4, Btn } from '../../../AbstractElements';
import { Delete, Edit } from '../../../Constant';
import { ProductListData } from '../../../Data/Ecommerce/ProductList';

const ProductDataTable = () => {
  const [productTable, setProductTable] = useState(ProductListData);

  const deleteHandler = (id) => {
    setProductTable({
      productData: productTable.productData.filter((item) => item.id !== id),
      productColumns: productTable.productColumns,
    });
  };

  const productTableData = {
    productColumns: [...productTable.productColumns],
  };
  productTableData.productData = productTable.productData.map((item) => {
    return {
      image: (
        <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
          <Image src={require(`../../../assets/images/ecommerce/${item.image}`)} />
        </Link>
      ),
      details: (
        <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
          <H4>{item.title}</H4>
          <span>{item.description}</span>
        </Link>
      ),
      amount: `$${item.amount}`,
      stock: <div className={`font-${item.stock >= 1 ? (item.stock <= 5 ? 'primary' : 'success') : 'danger'} `}>{item.stock >= 1 ? (item.stock <= 5 ? 'Low Stock' : 'In Stock') : 'Out of stock'}</div>,
      start_date: item.start_date,
      action: (
        <div className='d-flex gap-2'>
          <span>
            <Btn onClick={() => deleteHandler(item.id)} style={{ width: 60, fontSize: 13, padding: 3 }} size='xs' color='danger'>
              {Delete}
            </Btn>
          </span>
          <span>
            <Btn style={{ width: 60, fontSize: 13, padding: 3 }} size='xs' color='primary'>
              {Edit}
            </Btn>
          </span>
        </div>
      ),
    };
  });

  return (
    <div className='table-responsive product-table'>
      <div id='basic-1_wrapper' className='dataTables_wrapper no-footer'>
        <DataTable pagination columns={productTableData.productColumns} data={productTableData.productData} />
      </div>
    </div>
  );
};

export default ProductDataTable;
